import { CarType, CommonAction } from '@digital-dealer/enums';
import { TTextsOverride } from '@digital-dealer/texts-service';
import { LeasingStep, CitizenType, HousingType } from '@leasing/enums';
import LeasingAction from '@leasing/model-viewer/enums/LeasingAction';

const textsOverride: TTextsOverride = {
  common: {
    moneyUnits: {
      businessType: 'kr. pr. md.',
    },
  },
  modules: {
    modelChooser: {
      priceFrom: {
        [CarType.Van]: 'Erhvervsleasing fra',
      },
    },
    modelViewer: {
      checkout: {
        title: {
          [CarType.PersonalCar]: 'Leasing',
          [CarType.Van]: 'Leasing',
        },
        total: 'Månedlig ydelse',
      },
    },
  },
  leasing: {
    housingType: {
      [HousingType.Ownership]: 'Ejerbolig',
      [HousingType.Rental]: 'Lejebolig',
      [HousingType.Shared]: 'Andelsbolig',
      [HousingType.Parental]: 'Hjemmeboende',
    },
    citizenType: {
      [CitizenType.Citizenship]: 'Ja',
      [CitizenType.ResidentPermit]: 'Nej - har permanent opholdstilladelse',
      [CitizenType.Foreigner]: 'Nej',
    },
    fields: {
      labels: {
        creditValidation: {
          bankRegNumber: 'Bank, reg.nr.',
          bankAccountNumber: 'Bank, kontonr.',
          yearlyIncome: 'Din årlige bruttoindkomst',
          monthlyAvailableAmount: 'Din husstands månedlige rådighedsbeløb',
          numberOfAdults: 'Antal voksne i husstanden',
          numberOfAdultsHelper: 'Børn over 18 år medregnes ikke',
          numberOfChildren: 'Antal børn i husstanden',
          numberOfChildrenHelper: 'Børn over 18 år medregnes ikke',
          housingType: 'Nuværende boligform',
          citizenType: 'Er du dansk statsborger?',
        },
      },
      errors: {
        creditValidation: {
          bankRegNumber: 'Forkert bank reg.nr.',
          bankAccountNumber: 'Forkert bank konto nr.',
        },
      },
    },
    common: {
      duration: 'Leasingperiode',
      downPayment: 'Udbetaling',
      totalPriceForPeriod: 'Totalomkostning',
      units: {
        kmPerYear: 'km/år',
        months: 'måneder',
      },
    },
    modules: {
      modelChooser: {
        subTitle: {
          [CarType.PersonalCar]: '',
          [CarType.Van]: 'Alle priser er vist eksklusiv moms',
        },
      },
      modelViewer: {
        configuration: {
          steps: {
            [LeasingStep.LeasingOptions]: {
              title: 'Leasingpakke',
              expandedTitle: 'Vælg leasingpakke',
              kilometerOption: {
                title: 'Kilometerpakke',
              },
            },
          },
        },
        checkout: {
          totalPriceForPeriod: {
            totalPaymentForPeriod: (period: number): string => `Leasingydelse - månedligt x ${period} måneder`,
            deliveryCost: 'Afleveringsgebyr',
            total: 'Total',
          },
          additionalTechnicalSpecs: {
            residualValue: 'Restværdi',
          },
          actions: {
            [LeasingAction.PurchaseOnline]: {
              actionButtonTitle: 'Bestil online',
              title: 'Bestil online',
              successPage: {
                title: 'Tillykke',
                description: 'Du vil blive kontaktet hurtigst muligt',
              },
            },
          },
          hints: {
            [LeasingAction.PurchaseOnline]: [
              'Udfyld formularen for at starte bestillingen af din nye bil.',
              'Du vil herefter blive kontaktet hurtigst muligt i forbindelse med den lovpligtige kreditgodkendelse.',
              'Når din kreditgodkendelse er færdigbehandlet, kontakter vi dig igen for at færdiggøre din bestilling og aftale nærmere omkring levering af din bil.',
            ],
            [CommonAction.OfferRequest]: [
              'Udfyld formularen og send din forespørgsel om et tilbud.',
              'Vores leasingrådgiver vil modtage din henvendelse, forberede sig ved bl.a. at sætte sig ind i dine ønsker og kontrolere lager situationen.',
              'Leasingrådgiveren vil herefter kontakte dig for at udarbejde et uforpligtende skræddersyet tilbud til dig, så du får den leasingpakke der passer bedst til dine behov.',
            ],
          },
        },
      },
    },
  },
};

export default textsOverride;
